<template>
  <div class="UserAccount">
    <b-modal size="lg" id="bv-modal-address" hide-footer>
          <template v-slot:modal-title>Dirección de Residencia</template>
          <div class="detalleAddress">
            <ValidationObserver ref="obsFieldsAddress">
              <FormAddress :FieldsForm="formAddress" :ModelForm="this.formAddModel" :method="executeProcess" />
            </ValidationObserver>
            <div class="row botonData">
              <div class="text-left  col-md-10">
              </div>
              <div class="text-right  col-md-2">
                <button type="submit" v-on:click="executeAddress" class="botonRef">Aplicar</button>
              </div>
            </div>
          </div>
      </b-modal>
    <div class="titlePage">MI PERFIL</div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 totalform">
            <va-notification color="danger" v-if="checkTerminos" class="refNoData">Debe aceptar las politicas de privacidad del portal.</va-notification>
          <ValidationObserver ref="obsFieldsUpdate">
            <FormUpdateClient
              v-if="renderComponent1"
              :FieldsForm="formUpdate"
              :ModelForm="formUpdModel"
              :method="executeProcess"
            />
          </ValidationObserver>
          <div class="col-md-6 float-left">
            <div class="refNoData">
                <va-notification color="info" v-if="addRExito" class="refNoData">Se actualizo correctamente el usuario solicitado.</va-notification>
                <va-notification color="danger" v-if="refNoUpdate" class="refNoData">La actualizacion del usuario presento un fallo.</va-notification>
                <va-notification color="danger" v-if="refWSUpdate" class="refNoData">El servicio que ejecuta la actualización no se encuentra activo.</va-notification>
            </div>
          </div>
          <div class="float-right">
            <button
              type="submit"
              v-on:click="updateForm()"
              class="loginbtn primaryBtn"
            >Actualizar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormUpdateClient from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import FormAddress from '@/components/Forms.vue'

export default {
  name: 'Account',
  components: {
    FormUpdateClient,
    FormAddress,
  },
  data () {
    return {
      formUpdModel: {
        idUpdatedBy: this.$session.get('IberoJWTAdminLogin').idPerson,
        IdPerson: '',
        IdDocType: '',
        IdDocTypeName: '',
        IdDocument: '',
        IdBanner: '',
        IdNombre: '',
        IdApellidos: '',
        IdAddress: '',
        IdMail: '',
        IdCelPhone: '',
        IdHomePhone: '',
        IdState: '',
        IdCity: '',
        IdFileDoc: '',
        IdTermiCondi: '',
        IdNewsLetter: '',
        IdObservaciones: 'Update by User',
        IdTransferCenter: [],
        IdStatus: true,
      },
      formAddModel: {
        IdAddressList: '',
        IdAddressStreet: '',
        IdAddressNumTxt: '',
        IdAddressNum: '',
        IdAddressRefTxt: '',
        IdAddressRef: '',
        IdAddressExtra: '',
      },
      renderComponent1: false,
      checkTerminos: false,
      addRExito: false,
      refNoUpdate: false,
      refWSUpdate: false,
      formAddress: [
        {
          id: 'IdAddressList',
          model: 'IdAddressList',
          type: 'Select2',
          values: this.$store.state.listAddress,
          placeholder: 'Dirección',
          validate: {
            required: true,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdAddressStreet',
          model: 'IdAddressStreet',
          type: 'input',
          values: this.$store.state.listAddress,
          placeholder: 'Dirección',
          validate: {
            required: true,
            alpha_num: true,
            max: 4,
          },
          class: 'col-md-2',
        },
        {
          id: 'IdAddressNumTxt',
          model: 'IdAddressNumTxt',
          type: 'html',
          values: '#',
          class: 'col-md-1',
        },
        {
          id: 'IdAddressNum',
          model: 'IdAddressNum',
          type: 'input',
          values: '',
          placeholder: '#',
          validate: {
            required: true,
            alpha_num: true,
            max: 4,
          },
          class: 'col-md-2',
        },
        {
          id: 'IdAddressRefTxt',
          model: 'IdAddressRefTxt',
          type: 'html',
          values: '-',
          class: 'col-md-1',
        },
        {
          id: 'IdAddressRef',
          model: 'IdAddressRef',
          type: 'input',
          placeholder: '#',
          values: '',
          validate: {
            required: true,
            alpha_num: true,
            max: 4,
          },
          class: 'col-md-2',
        },
        {
          id: 'IdAddressExtra',
          model: 'IdAddressExtra',
          type: 'input',
          placeholder: 'Informacion adicional',
          values: '',
          validate: {
            max: 35,
          },
          class: 'col-md-11',
        },
      ],
      formUpdate: [
        {
          id: 'IdDocTypeName',
          model: 'IdDocTypeName',
          name: 'Tipo de identificación',
          type: 'informative',
          placeholder: 'Tipo de identificación',
          values: '',
          validate: {
            required: false,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdDocument',
          model: 'IdDocument',
          name: 'Documento de Identidad',
          type: 'informative',
          placeholder: 'Documento de Identidad',
          values: '',
          validate: {
            required: false,
            max: 15,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdBanner',
          model: 'IdBanner',
          name: 'Id Banner',
          type: 'informative',
          placeholder: 'Id Banner',
          values: '',
          validate: {
            required: false,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdNombre',
          model: 'IdNombre',
          name: 'Nombres',
          type: 'input',
          placeholder: 'Nombres',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdApellidos',
          model: 'IdApellidos',
          name: 'Apellidos',
          type: 'input',
          placeholder: 'Apellidos',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdAddress',
          model: 'IdAddress',
          name: 'Dirección',
          type: 'inputkey',
          placeholder: 'Dirección',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdMail',
          model: 'IdMail',
          name: 'Correo Electrónico Personal',
          type: 'input',
          placeholder: 'Correo Electrónico Personal',
          values: '',
          validate: {
            required: true,
            email: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdCelPhone',
          model: 'IdCelPhone',
          name: 'Teléfono Celular',
          type: 'input',
          placeholder: 'Teléfono Celular',
          values: '',
          validate: {
            required: true,
            numeric: true,
            max: 10,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdHomePhone',
          model: 'IdHomePhone',
          name: 'Teléfono Fijo',
          type: 'input',
          placeholder: 'Teléfono Fijo',
          values: '',
          validate: {
            required: false,
            numeric: true,
            max: 7,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdState',
          model: 'IdState',
          name: 'Departamento',
          type: 'Select',
          placeholder: 'Departamento',
          class: 'col-md-3',
          values: this.$store.state.StateList,
          validate: {
            required: true,
          },
        },
        {
          id: 'IdCity',
          model: 'IdCity',
          name: 'Ciudad',
          type: 'Select',
          placeholder: 'Ciudad',
          validate: {
            required: true,
          },
          class: 'col-md-3',
          values: this.$store.state.CityList,
        },
        {
          id: 'IdFileDoc',
          model: 'IdFileDoc',
          name: 'Archivo',
          type: 'file',
          placeholder: 'Archivo',
          validate: {
            required: false,
          },
          class: 'col-md-6',
          values: '',
          hidden: true,
        },
        {
          id: 'IdNewsLetter',
          name: 'Informacion Comercial',
          model: 'IdNewsLetter',
          type: 'accepted',
          placeholder: 'Recibir informacion comercial',
          disabled: false,
          validate: {
            required: false,
          },
          class: 'col-md-12 linkref',
        },
        {
          id: 'IdTermiCondi',
          name: 'Politicas de privacidad',
          model: 'IdTermiCondi',
          type: 'accepted',
          placeholder: 'He leído y acepto las <a class="linkTerm" href="https://www.ibero.edu.co/terminos-y-condiciones/" target="_blank">politicas de privacidad</a> de protección de datos.',
          disabled: false,
          validate: {
            required: true,
          },
          class: 'col-md-12 linkref',
        },
      ],
    }
  },
  methods: {
    limpiaref () {
      this.checkTerminos = false
      this.addRExito = false
      this.refNoUpdate = false
      this.refWSUpdate = false
    },
    updateForm () {
      this.limpiaref()
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsUpdate.validate().then(results => {
          if (!results) {
            resolve(false)
          } else {
            let loader = this.$loading.show()
            var totalinf = IberoHelpers.sendFormUpdate(
              this.$store,
              this.formUpdModel,
            )
            totalinf.then(Response => {
              if (Response === false) {
                this.refWSUpdate = true
                resolve(false)
              } else if (!(Response.status === 200)) {
                this.refNoUpdate = true
                resolve(false)
              } else {
                this.renderComponent1 = false
                this.addRExito = true                
                
                var token = IberoHelpers.getToken(this.$store)
                token.then(Response2 => {
                var logininf = IberoHelpers.getUserLoginAuth(
                  this.$store,
                  this.$session.get('IberoJWTAdmin').unique_name,
                  Response2
                )
                logininf.then(Response => {
                  if (Response === false) {
                    resolve(false)
                  } else {
                    var accountReload = !this.$session.get('IberoJWTAdminLogin').termsConditions
                    this.$session.set('IberoJWTAdminLogin', '')
                    this.$session.set('IberoJWTAdminLogin', Response.data[0])
                    this.callLoadData()
                    if (accountReload) {
                      IberoHelpers.forceRerender1(this)
                      resolve(true)
                      window.location.reload()
                    }
                  }
                  loader.hide()
                })
              })
                IberoHelpers.forceRerender1(this)
                resolve(true)
              }
              loader.hide()
            })
          }
        })
      })
    },
    /* loadFindData: function (restJson) {
      var datFind = JSON.parse(restJson.Detail)
      this.formInsModel.IdAddress = datFind.ResAddress

      this.formAddModel.IdAddressList = datFind.ResAddressZone
      this.formAddModel.IdAddressStreet = datFind.ResAddressStreet
      this.formAddModel.IdAddressNum = datFind.ResAddressNumber
      this.formAddModel.IdAddressRef = datFind.ResAddressReference
      this.formAddModel.IdAddressExtra = datFind.ResAddressAditional

      this.formInsModel.IdNeighbor = datFind.ResNeighborhood
      this.formInsModel.IdStateRes = datFind.CodResidenceDepartment

      IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric, this.$store.state.CityListRes, datFind.CodResidenceDepartment)
      this.formInscription.fields2[3].values = this.$store.state.CityListRes

      this.formInsModel.IdCityRes = datFind.CodResidenceCity
      return true
    }, */
    executeProcess: function (event) {
      debugger
      switch (event.target.id) {
        case 'IdState':
          this.formUpdModel.IdCity = ''
          if (event.target.value === '') {
            this.formUpdate[10].values = ''
          } else {
            IberoHelpers.getCitiesListByState(
              this.$store.state.ApiIbero.WSParametric,
              this.$store.state.CityList,
              event.target.value,
            )
            this.formUpdate[10].values = this.$store.state.CityList
          }
          break
        case 'cbox_IdTermiCondi':
          event.target.disabled = true
          break
        case 'IdAddress':
          this.$root.$emit('bv::show::modal', 'bv-modal-address', '#btnShow')
          break
      }
    },
    executeAddress: function () {
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsAddress.validate().then(results => {
          if (!results) {
            IberoHelpers.scrollToTop(0, 500)
            resolve(false)
          } else {
            debugger
            this.formUpdModel.IdAddress = this.dataObjFindJs(this.$store.state.listAddress, this.formAddModel.IdAddressList) + ' ' + this.formAddModel.IdAddressStreet + ' # ' + this.formAddModel.IdAddressNum + ' - ' + this.formAddModel.IdAddressRef
            if (this.formAddModel.IdAddressExtra !== '') {
              this.formUpdModel.IdAddress += ' | ' + this.formAddModel.IdAddressExtra
            }
            this.$root.$emit('bv::hide::modal', 'bv-modal-address', '#btnHide')
            resolve(true)
          }
        })
      })
    },
    dataformat: function (InfDaT) {
      return IberoHelpers.dataObjDate(InfDaT)
    },
    dataObjFindJs: function (infoDaT, FinDaT) {
      return IberoHelpers.dataObjFind(infoDaT, FinDaT)
    },
    dataObjAllFind: function (infoDaT, FinDaT) {
      return IberoHelpers.dataObjAllFind(infoDaT, FinDaT)
    },
    callLoadData: function () {
      debugger
      IberoHelpers.getCitiesListByState(
        this.$store.state.ApiIbero.WSParametric,
        this.$store.state.CityList,
        this.$session.get('IberoJWTAdminLogin').codResidenceDepartment,
      )
      this.formUpdModel.IdPerson = this.$session.get('IberoJWTAdminLogin').idPerson
      this.formUpdModel.IdDocType = this.$session.get('IberoJWTAdminLogin').idDocumentType
      this.formUpdModel.IdDocTypeName = IberoHelpers.dataObjFind(this.$store.state.DocTypesList, this.$session.get('IberoJWTAdminLogin').idDocumentType)
      this.formUpdModel.IdDocument = this.$session.get('IberoJWTAdminLogin').numDocument
      this.formUpdModel.IdBanner = this.$session.get('IberoJWTAdminLogin').idBanner
      this.formUpdModel.IdNombre = this.$session.get('IberoJWTAdminLogin').namPerson
      this.formUpdModel.IdApellidos = this.$session.get('IberoJWTAdminLogin').lastNamePerson
      this.formUpdModel.IdAddress = this.$session.get('IberoJWTAdminLogin').resAddress

      this.formAddModel.IdAddressList = this.$session.get('IberoJWTAdminLogin').ResAddressZone
      this.formAddModel.IdAddressStreet = this.$session.get('IberoJWTAdminLogin').ResAddressStreet
      this.formAddModel.IdAddressNum = this.$session.get('IberoJWTAdminLogin').ResAddressNumber
      this.formAddModel.IdAddressRef = this.$session.get('IberoJWTAdminLogin').ResAddressReference
      this.formAddModel.IdAddressExtra = this.$session.get('IberoJWTAdminLogin').ResAddressAditional

      if (this.$session.get('IberoJWTAdminLogin').termsConditions === true) {
        this.formUpdModel.IdTermiCondi = this.$session.get('IberoJWTAdminLogin').termsConditions
      }
      this.formUpdate[13].disabled = this.$session.get('IberoJWTAdminLogin').termsConditions
      this.formUpdModel.IdNewsLetter = this.$session.get('IberoJWTAdminLogin').infReceive

      this.formUpdModel.IdHomePhone = ''
      this.formUpdModel.IdCelPhone = ''
      this.formUpdModel.IdMail = ''

      if (this.$session.get('IberoJWTAdminLogin').information !== undefined) {
        for (var i = 0; i < this.$session.get('IberoJWTAdminLogin').information.length; i++) {
          if (
            this.$session.get('IberoJWTAdminLogin').information[i].idContactType === 1
          ) {
            this.formUpdModel.IdHomePhone = this.$session.get('IberoJWTAdminLogin').information[i].desContactInformation
          } else if (
            this.$session.get('IberoJWTAdminLogin').information[i].idContactType === 2
          ) {
            this.formUpdModel.IdCelPhone = this.$session.get('IberoJWTAdminLogin').information[i].desContactInformation
          } else if (
            this.$session.get('IberoJWTAdminLogin').information[i].idContactType === 3
          ) {
            this.formUpdModel.IdMail = this.$session.get('IberoJWTAdminLogin').information[i].desContactInformation
          }
        }
      }
      this.formUpdModel.IdState = this.$session.get('IberoJWTAdminLogin').codResidenceDepartment
      this.formUpdModel.IdCity = this.$session.get('IberoJWTAdminLogin').codResidenceCity
      this.formUpdModel.IdTransferCenter = this.$session.get('IberoJWTAdminLogin').transferCenterModels
    },
  },
  created: function () {
    this.callLoadData()
    IberoHelpers.forceRerender1(this)
    if (!this.$session.get('IberoJWTAdminLogin').termsConditions) {
      this.checkTerminos = true
    }
  },
}
</script>
